import { render, staticRenderFns } from "./UserMgmt.vue?vue&type=template&id=9f35ad80&scoped=true"
import script from "./UserMgmt.vue?vue&type=script&lang=js"
export * from "./UserMgmt.vue?vue&type=script&lang=js"
import style0 from "./UserMgmt.vue?vue&type=style&index=0&id=9f35ad80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f35ad80",
  null
  
)

export default component.exports